import React from 'react';
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

class DialogComentariosPanel extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            comentarios: this.props.comentarios === '' 
                ? 'SIN COMENTARIOS' 
                : this.props.comentarios
        }
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Comentarios del inventario</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            {this.state.comentarios}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default DialogComentariosPanel;